export const formatCents = cents => {
    const dollars = cents / 100;
    return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0 })}`;
};

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

// Feature bullets for a plan from billing/plans config (see botcircuits-backend billing/stripe-setup/plans.json)
export function planFeatures(plan) {
    const conversations = plan.conversationHardCap
        ? `${plan.includedConversations.toLocaleString('en-US')} conversations / month`
        : `${plan.includedConversations.toLocaleString('en-US')} conversations / month, then ${formatCents(plan.overagePer100ConversationsCents)} per 100`;

    return [
        conversations,
        plan.includedAiUsageCents != null
            ? `${formatCents(plan.includedAiUsageCents)} AI usage included`
            : plan.aiUsageCapCents != null ? `AI usage covered up to ${formatCents(plan.aiUsageCapCents)} / month` : 'AI usage covered',
        `Customer memory: ${plan.customerMemory}`,
        plural(plan.playbooks, 'playbook'),
        plan.channels == null ? 'All channels + API' : plural(plan.channels, 'channel'),
        plan.additionalSeatCents != null
            ? `${plural(plan.helpdeskSeatsIncluded, 'helpdesk seat')}, extra ${formatCents(plan.additionalSeatCents)} / month`
            : plural(plan.helpdeskSeatsIncluded, 'helpdesk seat'),
        plan.brandingRemovable ? 'Removable branding' : 'Powered by BotCircuits branding',
        plan.byokAddonCents != null ? `Bring your own AI key (+${formatCents(plan.byokAddonCents)} / month)` : null,
        `${plan.support} support`,
    ].filter(Boolean);
}
